<template>
    <b-overlay :show="load" class="animated">
        <modal-trash-basket
            v-if="show_modal"
            :entity_type="entity_type"
            :trash="trash"
            @onUpdate="onUpdate"
        />
        <div class="animated">
            <v-server-table
                :columns="table_config.columns"
                :options="table_config.options"
                :theme="theme"
                :ref="ref"
                @onUpdate="onUpdate"
                :collection="quality_control_collection"
            >
            <span slot="beforeTable" class="pt-3">
                <quality-control-table-filters 
                    @onSelect="setCustomFilter"
                    @ready="load = false"
                />
            </span>
                <span slot="name" slot-scope="{ row }">
                    <a :href="`#/quality-control/${row.id}`" class="btn-link">{{ row.name }}</a>
                </span>
                <span slot="sample_type" slot-scope="{ row }">
                    {{row.sample_type.name}}
                </span>
                <span slot="schedulable_task_type" slot-scope="{ row }">
                    {{formatTaskName(row.schedulable_task_type) }}
                </span>
                <span slot="task" slot-scope="{ row }">
                    {{ displayTaskName(row) }}
                </span>
                <span slot="actions" slot-scope="{ row }">
                    <a
                        v-show="checkPermission('edit quality control')"
                        class="btn btn-warning px-1 py-0 text-white mr-1"
                        :href="`#/quality-control/${row.id}/edit`"
                    >
                        <i class="fa fa-pencil" />
                    </a>
                    <template v-if="checkPermission('delete quality control')">
                        <a
                          v-if="isDeleted(row.id)"
                          class="btn btn-success px-1 py-0 text-white mr-1"
                          @click="restoreFromTrash(row.id)"
                        >
                          <i class="fa fa-refresh" />
                        </a>
                        <a
                          v-else
                          class="btn btn-danger px-1 py-0 text-white mr-1"
                          @click="putToTrash(row)"
                        >
                          <i class="fa fa-trash" />
                        </a>
                    </template>
                </span>
            </v-server-table>
        </div>
    </b-overlay>
</template>
<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import { ServerTable } from "vue-tables-2";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import QualityControlCollection from "@/collections/lab/QualityControlCollection";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { mapActions, mapGetters } from "vuex";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import { formatModelPath, stripTaskFromName } from "@/shared/utils";
import QualityControlTableFilters from "./QualityControlTableFilters";
import { getCollection } from "@/shared/fetch-utils";
    
Vue.use(ServerTable)

export default {
    name: "QualityControlTable",
    extends: BaseServerTable,
    mixins: [ToastNotifications],
    components: {
        ServerTable,
        ModalTrashBasket,
        QualityControlTableFilters,
    },
    props: {
        collection: {
            type: Object,
            default: () => new QualityControlCollection()
        },
        quality_control: {
            type: Object,
            default: () => null,
        },
        show_columns: {
            type: Array,
            default: () => [
                "name",
                "sheet_label",
                "sample_type",
                "schedulable_task_type",
                "task",
                "interval",
                "interval_index",
                "actions",
            ]
        },
        filterable: {
          type: Array,
          default: () => [],
        },
        sortable: {
          type: Array,
          default: () => [],
        },
        show_filters: {
          type: Boolean,
          default: true,
        },
    },
    data() {
        const actions_access =
            this.checkPermission("edit quality control") ||
            this.checkPermission("delete quality control");

        return {
            entity_type: "qualityControl",
            quality_control_collection: null,
            sample_type: [],
            load: true,
            table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
                options: {
                    headings: {
                        schedulable_task_type: "Task type"
                    },
                    filterable: this.filterable,
                    sortable: this.sortable,
                    debounce: 300,
                },
            }),
        };
    },
    computed: {
        ...mapGetters({
            trash: "qualityControlTrash",
        }),
        show_modal() {
            return (
                this.checkPermission("delete quality control") &&
                this.show_columns.includes("actions")
            );
        },
    },
    methods: {
        formatTaskName(str) {
            return stripTaskFromName(formatModelPath(str))
        },
        displayTaskName(row) {
            return row.getTestPackage().name;
        },
        displaySampleName(row) {
            let test_package = row.getTestPackage();
            
            if (!test_package.id) {
                return;
            }
            
            let sample = test_package.getSampleType();
            return sample.name;
        },
        ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
        putToTrash(value) {
            this.PUT_TO_TRASH({ value, name: this.entity_type });
        },
        restoreFromTrash(id) {
            this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
        },
        isDeleted(id) {
            return this.trash.find((item) => item.id === id);
        },
        checkPermission(permission) {
            return AccessControlCheck.checkPermission(permission);
        },
        onUpdate() {
            this.$refs[this.ref].refresh();
        },
    },
}
</script>